import { useState, useEffect, useRef } from "react";
import { getCombosJWT } from "../api/endpoints";

// Mapeo de endpoints .aspx viejos a tipos de catálogo del nuevo backend
const ASPX_TO_COMBO = {
    'api_impuestos.aspx': 'impuestos',
    'api_reparticiones.aspx': 'reparticiones',
    'api_estados_planes_pago.aspx': 'plan_pago_estados',
    'api_caracteres.aspx': 'caracteres',
    'api_tipos_archivo.aspx': 'tipos_archivo',
    'api_tipo_movimientos.aspx': 'tipo_movimientos',
    'api_personal.aspx': 'personal',
    'api_contraparte.aspx': 'contraparte',
    'api_modulos.aspx': 'modulos',
    'api_etapas_proceso.aspx': 'etapas_proceso',
    'api_juzgados.aspx': 'juzgados',
    'api_jurisdicciones.aspx': 'jurisdicciones',
    'api_objetos_reclamo.aspx': 'objetos_reclamo',
    'api_tipos_proceso.aspx': 'tipos_proceso',
    'api_estados_proceso.aspx': 'estados_proceso',
    'api_areas.aspx': 'areas',
};

function detectComboType(endpoint) {
    if (typeof endpoint === 'function') return null;
    const ep = String(endpoint || '').toLowerCase().replace(/^\/+/, '');

    for (const [aspx, tipo] of Object.entries(ASPX_TO_COMBO)) {
        if (ep.startsWith(aspx.toLowerCase())) return tipo;
    }

    // api_combos.aspx?combo=xxx
    const match = ep.match(/api_combos\.aspx\?combo=(\w+)/);
    if (match) {
        const comboMap = {
            'objetos_reclamo': 'objetos_reclamo',
            'tipos_proceso': 'tipos_proceso',
            'estados_proceso': 'estados_proceso',
        };
        return comboMap[match[1]] || match[1];
    }

    return null;
}

export function useComboData(endpoint) {
    const [items, setItems] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const abortRef = useRef(null);

    useEffect(() => {
        if (abortRef.current) abortRef.current.abort();
        const ctrl = new AbortController();
        abortRef.current = ctrl;

        setLoading(true);
        setError(null);

        const comboType = detectComboType(endpoint);

        if (comboType) {
            getCombosJWT(comboType)
                .then((data) => {
                    if (ctrl.signal.aborted) return;
                    setItems(data?.items || []);
                })
                .catch((e) => {
                    if (ctrl.signal.aborted) return;
                    setError(e?.message || "Error al cargar datos");
                })
                .finally(() => { if (!ctrl.signal.aborted) setLoading(false); });
        } else {
            // Endpoint no mapeado - retornar vacío sin error
            console.warn(`[useComboData] Endpoint no mapeado: ${endpoint}`);
            setItems([]);
            setLoading(false);
        }

        return () => ctrl.abort();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [endpoint]);

    return { items, loading, error };
}
